











































































import {
  ID,
  IResource, ObjectCollection,
} from 'simpli-web-sdk'
import {Component, Prop, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import {Period} from '@/enums/Period'
import {ItrackCollection} from '@/helpers'
import DeliveryVehicleRequest from '@/model/request/DeliveryVehicleRequest'

@Component
export default class FilterDeliveryVehicle extends Mixins(MixinMember) {
  @Prop({required: true}) value!: DeliveryVehicleRequest

  allTipoVeiculo = ItrackCollection.allTipoVeiculo

  Period = Period

  async mounted() {
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoInsumo.query()
    await this.allTipoVeiculo
  }

  get veiculoResource() {
    return ItrackCollection.allTipoVeiculoString.get(this.value.tipoVeiculo)
  }
  set veiculoResource(val: IResource | null) {
      this.value.tipoVeiculo = val && val.$id as string || null
  }

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
